import classNames from "classnames/bind";
import styles from "./Companies.module.css";
import Filter from "./Filter";
import { Alert, Loading, Pagination, Table, Toast } from "../../../components";
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { company } from "../../../services/api/comaniesService";
import { DeleteIcon, EditIcon } from "../../../components/Icons/Icons";
import { useNavigate } from "react-router-dom";
import NameCol from "../../../components/NameCol";
import { sorterArray } from "../../../utils";

const cx = classNames.bind(styles);

function Companies() {
  const [statusError, setStatusError] = useState(200)
  const [dataCompany, setDataCompany] = useState([])
  const [textSearch, setTextSearch] = useState()
  const [address, setAddress] = useState()
  const [loading, setLoading] = useState(false)
  const [alert, setAlert] = useState(false)
  const [companyCode, setCompanyCode] = useState()
  const [currentPage, setCurrentPage] = useState(1)
  const [pages, setPages] = useState(1)
  const [method, setMethod] = useState()
  const [toggleSort, setToggleSort] = useState(false)
  const [dataTable, setDataTable] = useState([])
  const [reGet, setReGet] = useState(false)
  const navigate = useNavigate()
  const handleChangeInfo = (code) => {
    navigate(`/admin/companies/${code}`)
  }
  const handleDeleteCompany = async () => {
    setLoading(true)
    try {
      let data = {
        company_code: companyCode,
      }
      const res = await company.delete(data);
      Toast.open('Xóa công ty thành công', 'success');
      setLoading(false);
      setAlert(false);
      setReGet(!reGet);
      return res;
    } catch (error) {
      if (error.response.status === 403) {
        Toast.open('Bạn không có quyền xóa công ty', 'danger')
      } else if (error.response.status === 500) {
        Toast.open(error.response.data[0], 'danger')
      } else {
        Toast.open('Xóa công ty không thành công', 'danger')
      }
      setLoading(false);
      setAlert(false);
    }
  }

  const showAlert = (code) => {
    setAlert(!alert)
    setCompanyCode(code)
  }

  const onChangeAddress = (data) => {
    setAddress(data)
  }

  const onChangeTextSearch = (e) => {
    setTextSearch(e.target.value)
  }

  const handleNext = () => {
    setCurrentPage(currentPage + 1)
  }
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1)
  }

  const handleChosePage = (data) => {
    setCurrentPage(data)
  }
  const getListCompanies = useCallback(async () => {
    try {
      let params = {
        company_name: textSearch,
        province_code: address,
        page: currentPage,
        size: 10
      }
      const res = await company.get(params);
      setDataCompany(res?.data)
    } catch (e) {
      if (e.response.status === 403) {
        Toast.open('Bạn không có quyền xem danh sách công ty', 'danger')
      } else {
        Toast.open('Không thể tải danh sách công ty', 'danger')
        setStatusError(e.response.status)
      }
    }
  }, [textSearch, currentPage, address])

  useEffect(() => {
    getListCompanies()
  }, [getListCompanies, reGet])


  useEffect(() => {
    const newData = dataCompany.length > 0 ? [...dataCompany] : null
    if (newData && method?.length > 0) {
      switch (toggleSort) {
        case 'up':
          const dataSortUp = sorterArray(newData, method)
          setDataTable(dataSortUp)
          break;
        case 'down':
          const dataSortDown = sorterArray(newData, method)
          setDataTable(dataSortDown.reverse())
          break;
        default:
          setDataTable(newData)
          break;
      }
    } else {
      setDataTable(newData)
    }
  }, [dataCompany, toggleSort, method])

  const handleSort = (type, method) => {
    if (type !== toggleSort) {
      setToggleSort(type)
      setMethod(method)
    } else {
      setToggleSort(false)
      setMethod('')
    }
  }
  const data = dataTable?.map((item, index) => {
    return {
      stt: index + 1,
      name: item.NAME,
      add: item.PROVINCE_NAME,
      // note: <div className={cx('center')}>{item.COUNT_USER}</div>,
      countCam: <div className={cx('center')}>{item.COUNT_CAM}</div>,
      taxCode: <div className={cx('center')}>{item.TAX_CODE}</div>,
      action: (<div className={cx('number-columns')}>
        <button onClick={() => handleChangeInfo(item?.CODE)}>
          <EditIcon />
        </button>
        <button onClick={(e) => showAlert(item?.CODE)}>
          <DeleteIcon />
        </button>
      </div>)
    }
  })

  const columns = [
    {
      label: "STT",
      key: "stt",
    },
    {
      label: <NameCol handleSort={handleSort} method={'NAME'} title={'Tên công ty'} active={method} />,
      key: "name",
    },
    {
      label: <NameCol handleSort={handleSort} method={'PROVINCE_NAME'} title={"Địa chỉ"} active={method} />,
      key: "add",
    },
    {
      label: <NameCol handleSort={handleSort} method={'COUNT_CAM'} title={"Số lượng camera"} active={method} />,
      key: "countCam",
    },
    {
      label: <NameCol handleSort={handleSort} method={'TAX_CODE'} title={"Mã số  công ty"} active={method} />,
      key: "taxCode",
    },
    {
      label: "Hành động",
      key: "action",
    },
  ];

  return (
    <div className={cx('wrapper')}>
      <div id="__notification"></div>
      <div className={cx('header')}>Quản trị công ty</div>
      {alert && <Alert title={'Bạn có muốn xóa công ty này không?'} onClose={() => setAlert(false)} onOk={handleDeleteCompany} />}
      <Filter
        input={textSearch}
        onChangeAddress={onChangeAddress}
        onChangeTextSearch={onChangeTextSearch}
        statusErr={statusError}
      />
      <Table data={data} colum={columns} />
      {data && data.length > 0 && (
        <div className={cx('pagination')}>
          <Pagination
            currentPage={currentPage}
            pages={pages}
            onClick={handleChosePage}
            onNext={handleNext}
            onPrevious={handlePrevious}
          />
        </div>
      )}
      {loading && (
        <div className={cx('loading-modal')}>
          <Loading />
        </div>
      )}
    </div>
  )
}

export default Companies;